import {
    StyleSheet
} from "react-native";
import {
    webStyle
} from "ncore-ui-kit";

const stylesheet = StyleSheet.create({
    tableRow: {
        flexDirection: "row",
        alignItems: "center",
        ...webStyle({
            transition: "all 0.2s ease-in-out",
            cursor: "pointer"
        })
    },
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        width: "100%"
    },
    emptyContainer: {
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    },
    colContact: {
        justifyContent: "center",
        flex: 3
    },
    colSector: {
        justifyContent: "center",
        flex: 2
    },
    colDate: {
        justifyContent: "center",
        flex: 2
    },
    colStatus: {
        justifyContent: "center",
        flex: 1
    },
    colActions: {
        justifyContent: "center",
        alignItems: "center",
        width: 50
    },
    avatarPlaceholder: {
        justifyContent: "center",
        alignItems: "center",
        height: 40,
        width: 40
    },
    listContainer: {
        flexDirection: "column",
        width: "100%"
    },
    filterDropdownContainer: {
        zIndex: 2,
        flex: 1
    },
    headerActions: {
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap"
    },
    filterSection: {
        flexDirection: "row",
        alignItems: "center"
    },
    tableHeaderRow: {
        flexDirection: "row",
        alignItems: "center"
    },
    colUser: {
        flexDirection: "row",
        alignItems: "center",
        flex: 2
    },
    emptyText: {
        textAlign: "center"
    },
    tableHeaderText: {
        fontWeight: "600"
    },
    searchContainer: {
        flex: 2
    },
    avatarImage: {
        height: 40,
        width: 40
    },
    container: {
        flex: 1
    }
});

export default stylesheet;
